import { trpc } from '@/shared/api';

/** 상품의 최신 편집 영역 버전 조회 — 미등록이면 null. */
export const useLatestEditAreaQuery = (productId: string, editing = false) =>
  trpc.editor.editAreas.getLatest.useQuery(
    { productId },
    editing
      ? {
          refetchOnWindowFocus: false,
          refetchOnReconnect: false,
          staleTime: 0,
          refetchOnMount: 'always',
        }
      : undefined,
  );
